import { createSelector, Selector } from "@reduxjs/toolkit";

import { getLatestFVManifests } from "../../app/slices/fachverfahren/selectors";
import { getLatestSDManifests } from "../../app/slices/stammdaten/selectors";
import { ModulFState } from "../../app/slices/store";

import { RuntimeManifestWithTextbaustein } from "./textbausteinDataProviderHelpers";

/**
 * Gibt die jeweils neuesten Manifeste aller Fachverfahren und Stammdaten zurück,
 * die Textbaustein-Daten unterstützen (Verfahren-Queries).
 */
export const getLatestTextbausteinManifests: Selector<ModulFState, RuntimeManifestWithTextbaustein[], never> =
	createSelector([getLatestFVManifests, getLatestSDManifests], (fvManifests, sdManifests) => [
		...fvManifests,
		...sdManifests
	]);
